import { CommonModule } from '@angular/common';
import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { DxRadioGroupModule } from 'devextreme-angular';
import { AppGlobals } from 'src/app/app.globals';
import { SvgIconComponent } from 'src/app/components/svg-icon/svg-icon.component';
import { FolderTreeConfigComponent } from '../folder-tree-config/folder-tree-config.component';
import { SandboxService } from 'src/app/services/sandbox.service';

@Component({
    selector: 'app-sandbox-folder-config',
    imports: [CommonModule, DxRadioGroupModule, FolderTreeConfigComponent, SvgIconComponent],
    templateUrl: './sandbox-folder-config.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './sandbox-folder-config.component.css'
})
export class SandboxFolderConfigComponent implements OnInit {
  @Input() context: 'site' | 'project' = 'site';
  structureMode: 'same' | 'custom' = 'same';

  readonly sandboxDescription = $localize`:@@sandboxSectionDescription:Define the folder structure that is automatically created in the sandbox when a new project is set up.`;
  readonly helpTooltip = $localize`:@@sandboxStructureHelpTooltip:Project documents that are currently being worked on and are not yet available in their final version can be stored in a separate SharePoint folder called "Sandbox". The Sandbox link can be configured under General.`;

  readonly structureModeOptions = [
    { value: 'same', label: $localize`:@@sandboxStructureSame:Adopt main structure` },
    { value: 'custom', label: $localize`:@@sandboxStructureCustom:Use custom sandbox structure` },
  ];

  constructor(private readonly service: SandboxService) {}

  ngOnInit(): void {
    this.load();
  }

  private async load(): Promise<void> {
    try {
      const result = await this.service.getSandboxSettings({});
      if (result.hasError === true) {
        AppGlobals.ShowErrorMessage(result.feedback);
        return;
      }
      this.structureMode = result.structureMode === 'custom' ? 'custom' : 'same';
    } catch (error: any) {
      AppGlobals.ShowErrorMessage(error);
    }
  }

  async onStructureModeChanged(e: any): Promise<void> {
    if (e.value === e.previousValue) return;
    try {
      const result = await this.service.saveSandboxStructureMode({ StructureMode: e.value });
      if (result.hasError === true) {
        AppGlobals.ShowErrorMessage(result.feedback);
        await this.load();
      }
    } catch (error: any) {
      AppGlobals.ShowErrorMessage(error);
    }
  }
}
